module.exports = __webpack_public_path__ + "static/img/flowPathPicture.b83829c5.png";